import styled from 'styled-components';

const Container = styled.div`
  padding: 2.4rem;
`;

const Note = styled.p`
  font-size: 1.4rem;
  color: #666;
  margin-bottom: 2.4rem;
  font-style: italic;
`;

const EmptyState = styled.p`
  font-size: 1.4rem;
  color: #999;
  text-align: center;
  padding: 4rem 0;
`;

const ProductCard = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 1.6rem;
  margin-bottom: 1.2rem;
`;

const ProductHeader = styled.div`
  display: flex;
  gap: 1.6rem;
  margin-bottom: 1.2rem;
  flex-wrap: wrap;
`;

const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`;

const FieldLabel = styled.span`
  font-size: 1.2rem;
  color: #666;
  text-transform: uppercase;
  font-weight: 600;
`;

const FieldValue = styled.span`
  font-size: 1.4rem;
  color: #333;
`;

const DescriptionSection = styled.div`
  margin-top: 1.2rem;
  padding-top: 1.2rem;
  border-top: 1px solid #f0f0f0;
`;

const DescriptionBlock = styled.div`
  margin-bottom: 0.8rem;
`;

const DescriptionText = styled.p`
  font-size: 1.3rem;
  color: #444;
  line-height: 1.5;
  margin: 0;
`;

export {
  Container,
  DescriptionBlock,
  DescriptionSection,
  DescriptionText,
  EmptyState,
  Field,
  FieldLabel,
  FieldValue,
  Note,
  ProductCard,
  ProductHeader,
};
